import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import {
  fetch2FAError,
  fetch2FASuccess,
  submit2FAError,
  submit2FASuccess,
  submitExpiredPassError,
  submitExpiredPassSuccess,
  submitLoginError,
  submitLoginSuccess,
  submitSSOError,
  submitSSOSuccess,
  useOtherCredentialsError,
  useOtherCredentialsSuccess,
  validateSessionError,
  validateSessionSuccess,
} from './actions'
import {
  FETCH_2FA_ASYNC,
  LOGIN_STEPS,
  SUBMIT_2FA_ASYNC,
  SUBMIT_EXPIRED_PASS_ASYNC,
  SUBMIT_LOGIN_ASYNC,
  SUBMIT_SSO_ASYNC,
  USE_OTHER_CREDENTIALS_ASYNC,
  VALIDATE_SESSION_ASYNC,
} from './constants'

const validateSessionEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(VALIDATE_SESSION_ASYNC.INITIATE).mergeMap(() =>
    api.login
      .validateSession()
      .map((response) => validateSessionSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(validateSessionError, error)))
  )

const useOtherCredentialsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(USE_OTHER_CREDENTIALS_ASYNC.INITIATE).mergeMap(() =>
    api.login
      .useOtherCredentials()
      .map((response) => useOtherCredentialsSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(useOtherCredentialsError, error)))
  )

const submitLoginEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(SUBMIT_LOGIN_ASYNC.INITIATE).mergeMap((action) =>
    api.login
      .submitLogin(action.payload.body)
      .map(({ response }) => submitLoginSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(submitLoginError, error)))
  )

const submitExpiredPassEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(SUBMIT_EXPIRED_PASS_ASYNC.INITIATE).mergeMap((action) =>
    api.login
      .submitExpiredPass(action.payload.body)
      .map(({ response }) => submitExpiredPassSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(submitExpiredPassError, error)))
  )

const submitSSOEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(SUBMIT_SSO_ASYNC.INITIATE).mergeMap((action) =>
    api.login
      .submitSSO(action.payload.body)
      .map(({ response }) => submitSSOSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(submitSSOError, error)))
  )

const fetch2FAEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(FETCH_2FA_ASYNC.INITIATE).mergeMap(() =>
    api.login
      .fetch2FA()
      .map((response) => fetch2FASuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(fetch2FAError, error)))
  )

const submit2FAEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(SUBMIT_2FA_ASYNC.INITIATE).mergeMap((action) =>
    api.login
      .submit2FA(action.payload.body)
      .map(({ response }) => submit2FASuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(submit2FAError, error)))
  )

const stepChangeEpic = (action$) =>
  action$
    .ofType(
      VALIDATE_SESSION_ASYNC.SUCCESS,
      SUBMIT_LOGIN_ASYNC.SUCCESS,
      SUBMIT_EXPIRED_PASS_ASYNC.SUCCESS,
      SUBMIT_SSO_ASYNC.SUCCESS,
      SUBMIT_2FA_ASYNC.SUCCESS
    )
    .mergeMap((action) =>
      Observable.of(() => {
        if (action.payload.data.step === LOGIN_STEPS.LOGGED && action.payload.data.redirectTo) {
          window.location = action.payload.data.redirectTo
        }
      })
    )

export default combineEpics(
  validateSessionEpic,
  useOtherCredentialsEpic,
  submitLoginEpic,
  submitExpiredPassEpic,
  submitSSOEpic,
  fetch2FAEpic,
  submit2FAEpic,
  stepChangeEpic
)
